module.exports = __webpack_public_path__ + "img/icon-starsend.d533dcda.svg";